import React, { useState } from 'react';
import { ArrowDropDown as ArrowDropDownIcon, Check as CheckIcon, Home as HomeIcon } from '@mui/icons-material';
import { Button, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Link, useMatch } from 'react-router-dom';
import SiteLogo from '../logos/SiteLogo';
import { useLeagueSelectorItems } from './useLeagueSelectorItems';

// Mobile-only brand button: doubles as the site's branding and the way back to "/" (there's no
// address bar to type into once installed as an iOS home-screen app), and as the league switcher
// so switching leagues doesn't cost a trip through the home page. "Home" is pinned above the
// league list, same pattern as a workspace switcher.
function BrandMenu() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null);
  const { leagues, currentLeague, leagueId, navigateToLeague } = useLeagueSelectorItems();
  const isHome = Boolean(useMatch('/'));

  return (
    <>
      <Button
        sx={{ color: 'common.white', textTransform: 'inherit', minWidth: 0, maxWidth: '100%' }}
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        <SiteLogo sx={{ mr: 1, flexShrink: 0 }} />
        <Typography variant="h6" component="span" noWrap sx={{ minWidth: 0 }}>
          {currentLeague ? currentLeague.name : 'College Pick Em'}
        </Typography>
        <ArrowDropDownIcon sx={{ flexShrink: 0 }} />
      </Button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem component={Link} to="/" selected={isHome} onClick={() => setAnchorEl(null)}>
          <ListItemIcon>
            <HomeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Home</ListItemText>
          {isHome && <CheckIcon fontSize="small" sx={{ ml: 2 }} />}
        </MenuItem>
        <Divider />
        {leagues.length === 0 && <MenuItem disabled>No leagues yet</MenuItem>}
        {leagues.map(league => (
          <MenuItem
            key={league.id}
            selected={league.id === leagueId}
            onClick={() => {
              setAnchorEl(null);
              navigateToLeague(league);
            }}
          >
            {league.id === leagueId && (
              <ListItemIcon>
                <CheckIcon fontSize="small" />
              </ListItemIcon>
            )}
            <ListItemText inset={league.id !== leagueId}>{league.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default BrandMenu;
